import { CrudModel } from "./_crud";

export class DiseaseAppModel extends CrudModel {
	constructor() {
		super("app/disease");
	}
}

export default new DiseaseAppModel();
